<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions">
      <router-link
        class="btn btn-success"
        :to="{ name: 'oauth_application_create' }"
        tag="button"
        v-if="can('write_oauth_applications')"
        >{{ 'routes_oauth_application_create' | t }}</router-link
      >
    </div>
    <div class="card">
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Application id</th>
            <th>Scopes</th>
            <th v-if="can('write_oauth_applications')"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(app, i) in applications">
            <td>{{ app.name }}</td>
            <td>{{ app.uid }}</td>
            <td>{{ app.scopes }}</td>
            <th v-if="can('write_oauth_applications')">
              <a class="text-danger" @click="destroy(app.id, i)">Delete</a>
            </th>
          </tr>
        </tbody>
      </table>
    </div>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';

export default {
  data: function () {
    return {
      applications: []
    };
  },
  methods: {
    async destroy(app_id, idx) {
      await Api.destroy('oauth_applications', app_id);
      this.applications.splice(idx, 1);
    }
  },
  async mounted() {
    this.setBreadcrumbs([{ to: { name: 'oauth_applications' }, text: 'OAuth Applications' }]);

    let { data: applications } = await Api.findAll('oauth_applications');

    this.applications = applications;
  },
  props: ['address']
};
</script>

<style scoped></style>
